import { useSelector } from 'react-redux';

import useLocalStorageSync from '@app/hooks/useLocalStorageSync';
import { getEmail } from '@app/store/user/user/selectors';

export function useUserScopedLocalStorage<Value>(key: string, initialValue: Value) {
  const email = useSelector(getEmail);

  const isAnonymousUser = email == null;

  if (process.env.REACT_APP_MODUSIGN_ENV !== 'production') {
    if (isAnonymousUser) {
      throw new Error('user email should exist');
    }
  }

  return useLocalStorageSync<Value>(
    `__modusign__${isAnonymousUser ? 'anonymousUser' : email}__${key}`,
    initialValue
  );
}
